import React from "react";

import { message, Button, Space, Row, Col, Modal, Image, Drawer,Tooltip } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import MenuSettingAdd from "./MenuSettingAdd";

import CompanyAutocomplete from "./CompanyAutocomplete";
import MenuSettingStore from "../store/MenuSettingStore";
import CompanyStore from "../store/CompanyStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";

class CompanyMenuSettingList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSearch = this.onSearch.bind(this);

    this.menuSettingStore = new MenuSettingStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      companyId_value_label: "",
      openMenuSettingForm: false,
      roleId: "",
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Role Name",
        title: context.translate("_FLEET_ROLE_ROLELIST_ROLENAME_"),
        dataIndex: "name",
        width: 50,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_ROLE_ROLELIST_STATUS_"),
        dataIndex: "status",
        width: 50,
        ellipsis: {
          showTitle: true,
        },
        // align: "center",
        render: (value) => {
          if (value == 1) {
            return <div className="list-status-active">Active</div>;
            // return <Tag color={config.activeColor}>Active</Tag>;
          } else if (value == 2) {
            return <div className="list-status-inactive">Inactive</div>;
            // return <Tag color="red">Inactive</Tag>;
          }
        },
      },
      {
        // title: "Action",
        title: context.translate("_ACTION_"),
        dataIndex: "",
        width: 10,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    placement="bottom"
                    // title="Edit Setting"
                    title={this.context.translate("_EDIT_SETTING_")}
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    this.onDelete(record);
                  }}
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <Tooltip
                      placement="bottom"
                      // title="Delete Setting"
                      title={this.context.translate("_DELETE_SETTING_")}
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}

                <Image
                  style={{
                    height: "19px",
                    width: "19px",
                    borderRadius: "0px",
                    cursor: "pointer",
                  }}
                  src={editIcon}
                  onClick={async (e) => {
                    e.preventDefault();
                    await this.onEdit(record);
                  }}
                ></Image>

                <Image
                  src={require("../assets/images/NewDesign/Delete.png")}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    this.setState({
                      openDeleteModal: true,
                      deleteData: record,
                    })
                  }
                ></Image>
              </Space>
            </>
          );
        },
      },
    ];
  }
  onEdit = async (record) => {
    console.log(record.roleId, "dd");
    this.context.viewStateStore.setMenuSettingStates({
      companyId: this.state.companyId,
    });
    // this.props.navigate("/menusettingadd/" + record.roleId);
    await this.setState({ roleId: record.roleId });
    await this.setState({ openMenuSettingForm: true });
  };
  async onDelete(record) {
    const response = await this.menuSettingStore.deleteRecord({
      roleId: record.roleId,
    });
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const menuSettingStates =
        this.context.viewStateStore.menuSettingStateObject;

      const singleData = await this.companyStore.getCompanyDataById(
        menuSettingStates.companyId
      );
      await this.setState({
        companyId_value_label: singleData,
        companyId: menuSettingStates.companyId,
      });
      await this.menuSettingStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: menuSettingStates.companyId,
        userId: this.state.userId,
        isadmin: this.props.getUserData().isadmin
      });
      this.setState({ listDataUpdate: false });
    }
  }
  async componentDidMount() {
    // await this.companyStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });

    // console.log(menuSettingStates)
    // await this.handleSearch();

    if (Number(this.props.getUserData().isadmin) !== -1 && Number(this.props.getUserData().isadmin) !== 3) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    await this.setState({ listUpdated: 1 }); //need to reload data
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ currentPage: 1, companyId: comp.value });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyId_value_label: singleData });
    await this.handleSearch();
  }

  async onSearch(value) {
    console.log(value);
    await this.setState({ emailId: value });
    this.handleSearch();
  }

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.menuSettingStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        userId: this.state.userId
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  async handleSearch() {
    this.setState({ loading: true });
    await this.menuSettingStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      userId: this.state.userId
    });
    await this.setState({ listUpdated: 1 }); //need to reload data
  }
  responseMsg = async (response) => {
    if (response?.success === "S") {
      message.success(response.message);
      // this.props.navigate("/companymenusetting");
      await this.setState({ listDataUpdate: true });
      await this.setState({ openMenuSettingForm: false });
    } else {
      message.error(response.message);
    }
  };

  closeModal = () => {
    this.setState({ openMenuSettingForm: false });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.companyId_value_label
                      ? this.state.companyId_value_label
                      : null
                  }
                  onChange={this.handleChange}
                  style={{ width: 200 }}
                  // allowClear={true}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space>

                 <Tooltip   
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
                  </Tooltip>
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openMenuSettingForm: true, roleId: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.menuSettingStore?.total}
            columns={this.columns}
            dataSource={this.menuSettingStore?.menuSetting}
            loading={this.menuSettingStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openMenuSettingForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Role Setting"
          //   title={this.context.translate("_ROLE_SETTING_")}
          //   centered
          //   visible={this.state.openMenuSettingForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openMenuSettingForm: false });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openMenuSettingForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ROLE_SETTING_")}
                <p className="formDescription">
                  {this.context.translate("_MENU_SETTING_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openMenuSettingForm: false })}
            onCancel={() =>
              this.setState({ openMenuSettingForm: false, roleId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <MenuSettingAdd
                roleId={this.state.roleId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
CompanyMenuSettingList.contextType = StoreContext;
export default observer(withRouter(CompanyMenuSettingList));
